<script>
  import { createEventDispatcher } from "svelte";
  import ToggleSwitch from "../input/ToggleSwitch.svelte";
  import { translate } from "../../i18n/i18next.js";
  import DialogTitle from "../dialog/DialogTitle.svelte";
  import DialogContent from "../dialog/DialogContent.svelte";
  import DialogSplitter from "../dialog/DialogSplitter.svelte";
  import DialogBase2 from "../dialog/DialogBase2.svelte";

  export let dialog
  export let GanttStore
  export let ganttChartType;

  const {
    ExtraColumns,
  } = GanttStore

  const dispatcher = createEventDispatcher();

  let extraColumnProperties = [];

  if (
    ganttChartType == GanttStore.GanttChartTypes.ResGantt ||
    ganttChartType == GanttStore.GanttChartTypes.SimpleResGantt
  ) {
    extraColumnProperties = [
      { name: "資源グループ", nameTranslationKey: "$t(asprova.terms.resourceGroup)", code: "ResourceGroup", expectedLength: 8},
      { name: "資源名", nameTranslationKey: "$t(asprova.terms.resourceName)", code: "ResourceName", expectedLength: 12 },
      { name: "シフト", nameTranslationKey: "シフト", code: "ResourceShift", expectedLength: 5}
    ];
  } else if (ganttChartType === GanttStore.GanttChartTypes.CustomizedResGantt) {
    extraColumnProperties = [{ name: "シフトの区切り時刻", nameTranslationKey: "$t(asprova.terms.shiftDemarcationTime)", code: "Res_MyScheduleSeparateTimeForCustomizedResGantt"}];
  } else {
    extraColumnProperties = [
      { name: "製番", nameTranslationKey: "製番", code: "Order_Seiban", expectedLength: 6},
      { name: "品目", nameTranslationKey: "品目", code: "Order_ItemCode", expectedLength: 10 },
      { name: "品名", nameTranslationKey: "品名", code: "Order_ItemName", expectedLength: 15},
      { name: "完成予定日", nameTranslationKey: "完成予定日", code: "Order_EndTime", expectedLength: 10},
      { name: "納期", nameTranslationKey: "$t(asprova.terms.due)", code: "Order_LET", expectedLength: 10 },
      { name: "納期遅れ", nameTranslationKey: "$t(asprova.terms.lateness)", code: "Order_Lateness", expectedLength: 3 }
    ];
  }

  function handleChange(name) {
    ExtraColumns.update(columns => {
      const columnIndex = columns.findIndex(column => column.name === name)
      if (columnIndex === -1) return columns
      const newColumns = [...columns]
      newColumns.splice(columnIndex, 1, {...columns[columnIndex], displayed: !columns[columnIndex].displayed})
      return newColumns
    })
  }
</script>

<DialogBase2 bind:dialog={dialog} width="" onClose={() => dispatcher("close")}>
  <DialogTitle title={translate("frontend:ganttChart.columnSettings.label")} />
  <DialogSplitter />
  <DialogContent>
    {#each $ExtraColumns as column}
      <div class="settings-item">
        <span class="label-text">
          {#if column.nameTranslationKey}
            {translate(column.nameTranslationKey)}
          {:else}
            {column.name}
          {/if}
        </span>
        <ToggleSwitch on={column.displayed} onChange={() => handleChange(column.name)} />
      </div>
    {/each}
  </DialogContent>
</DialogBase2>

<style>
  .settings-item {
    display: flex;
    gap: 1rem;
    justify-content: space-between;
  }
</style>